<template>
    <div class="lesson-tab-box">
        <el-tabs v-model="lessonType" @tab-click="handleClick">
            <el-tab-pane label="机构全部课程" name="publish"></el-tab-pane>
            <el-tab-pane label="机构推荐课程" name="join"></el-tab-pane>
            <component :is="tabs[lessonType]" :data="data" @edit="beforeEdit" @delete="beforeDelete" @out="beforeOut"  @moveup="beforeup"  @movedown="beforedown" @status-change="beforeChange" />
        </el-tabs>
        <el-pagination background prev-text="上一页" next-text="下一页" layout="total, prev, pager, next, jumper" :total="page.total" :current-page="page.currentPage" :page-size="page.pageSize" :pager-count="page.pagerCount" @current-change="handlePageChange" style="margin-top:15px" hide-on-single-page></el-pagination>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import lessonListDept from './components/lesson-list-dept'
import lessonListdeptRec from './components/lesson-list-dept-rec'
import { getDeptLessonList, getDeptRecomLessonList, remove  } from '@/api/lab/lesson'
import { convertLocalPath } from '@/utils/localAvartSrc'
import { setRecommendLesson, removeRecommend, moveIndex } from '@/api/system/deptRecommend'
export default {
    data () {
        return {
            page: {
                currentPage: 1, // 当前页
                pageSize: 5, // 每页条目数
                total: 0
            },
            tabs: {
                publish: 'lessonListDept',
                join: 'lessonListdeptRec'
            },
            // 列表数据
            data: [],
            activeStatus: '1',
            activeType: '0',
            // 列表类型 publish是该机构下的课堂，join推荐的课堂
            lessonType: 'publish',
        
        }
    },
    components: {
        lessonListDept,
        lessonListdeptRec
    },
    computed: {
        ...mapGetters(['userInfo', 'isAdmin', 'isTeacher', 'isStudent']),
    },
    created () {
        if (this.lessonType === 'publish') {
            this.lessonType = 'publish'
            this.getPublicList()
        } else {
            this.lessonType = 'join'
            this.getStudyList()
        }
    },
    methods: {
        // page 改变时会触发
        handlePageChange (page) {
            this.$set(this.page, 'currentPage', page)
            this.getLessonList()
        },
        convertLocalPath(src){
            return convertLocalPath(src)
        },
        /**
         * 点击标签事件
         */
        beforeChange (params) {
            var status =  params.status   
            var publicFlag = params.publicFlag
            this.activeStatus = params.status
            this.activeType = params.publicFlag
            if (this.lessonType == 'publish')
                this.getPublicList({ 'status': status, 'publicFlag': publicFlag, 'delFlag': 0})
            else if (this.lessonType == 'join')
                this.getStudyList({ 'status': status, 'publicFlag': publicFlag, 'delFlag': 0})
        },
        /**
         * 执行删除操作
         */
        beforeDelete (uid) {
            this.$confirm('此操作将永久删除该课堂, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                remove([uid]).then(() => {
                    this.$message.success('删除成功!')
                    this.getPublicList({ 'status': this.activeStatus, 'publicFlag': this.activeType })
                })
            }).catch(() => { })
        },
        beforeEdit (uid) { 
            setRecommendLesson(uid).then(() => {
                this.$message.success('设置推荐课程成功!')
                    this.getPublicList({ 'status': this.activeStatus, 'publicFlag': this.activeType })
            })
        },
        /**
         * 执行结课操作
         */
        // beforeEnd (id) {
        //     this.$confirm('是否确定结课?', '提示', {
        //         confirmButtonText: '确定',
        //         cancelButtonText: '取消',
        //         type: 'warning'
        //     }).then(() => {
        //         end([id]).then(() => {
        //             this.$message.success('操作成功!')
        //             this.getPublicList()
        //         })
        //     }).catch(() => { })
        // },
        /**
         * 学生退出课堂
         */
        beforeOut(uid){
            this.$confirm('此操作将取消推荐课堂, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                removeRecommend(uid).then(()=>{
                    this.$message.success('操作成功!')
                    this.getStudyList()
                })
            }).catch(() => { })
        },
        beforeup(uid){
            let type = 'up'
            moveIndex(uid, type).then(() => {
                this.$message.success('操作成功!')
                this.getStudyList()
          })
        },
        beforedown(uid){
            let type = 'down'
            moveIndex(uid, type).then(() => {
                this.$message.success('操作成功!')
                this.getStudyList()
          })
        },
        handleClick (i) {
            this.lessonType = i.name
            this.getLessonList()
        },
        // 获取课堂列表
        getLessonList () {
            this.data = []
            this.activeStatus
            if (this.lessonType == 'publish')
                this.getPublicList({ 'status': this.activeStatus, 'publicFlag': this.activeType, 'delFlag': 0 })
            else if (this.lessonType == 'join')
                this.getStudyList({ 'status': this.activeStatus, 'publicFlag': this.activeType, 'delFlag': 0})
        },
        
        /**
         * 获取部门下全部课堂列表
         */
        getPublicList (
            params = {
            delFlag: 0,    
            status: 1,
            publicFlag: 0
        }) {
            const { deptId } = this.userInfo;
            const { currentPage, pageSize } = this.page
            let obj = {
                ...params,
                deptId
            }
            getDeptLessonList(currentPage, pageSize, obj).then(res => {
                const { list, totalCount } = res
                this.page.total = totalCount
                this.data = list
            })
        },
        /**
         * 获取该机构下的推荐课程
         */
        getStudyList (params = {
            status: 1,
            publicFlag: 0
        }) {
            const { deptId } = this.userInfo;
            const { currentPage, pageSize } = this.page
            let obj = {
                ...params,
                deptId
            }
            getDeptRecomLessonList(currentPage, pageSize, obj).then(res => {
                const { list, totalCount } = res
                this.page.total = totalCount
                this.data = list
            })
        }
    }
}
</script>

<style lang="less">
.lesson-tab-box {
    position: relative;
    .el-form {
        .el-select,
        .el-input-number {
            width: 100%;
        }
    }
    .right-btn {
        position: absolute;
        top: 0;
        right: 0;
    }
    .lesson-status {
        margin-top: 24px;
        margin-bottom: 24px;
        .el-tag {
            cursor: pointer;
            & + .el-tag {
                margin-left: 18px;
            }
        }
    }
    .lesson-list {
        margin: -10px 0;
    }
    .lesson-item {
        padding: 10px 0;
        border-bottom: 1px solid #efefef;
        &:last-child {
            border-bottom: none;
        }
        > .el-col {
            vertical-align: text-bottom;
        }
    }
    .lesson-info {
        > .el-col {
            vertical-align: text-top;
        }
    }
    .lesson-pic {
        .el-image {
            width: 100%;
            height: 118px;
        }
        & + .el-col {
            padding-left: 24px;
        }
    }
    .lesson-main {
        & + .el-col {
            padding-left: 56px;
        }
    }
    .lesson-title {
        font-size: 1em;
    }
    .lesson-synopsis,
    .lesson-summary {
        font-size: 0.9em;
    }
    .lesson-synopsis {
        > span {
            color: #bdbdbd;
            > i {
                font-style: normal;
            }
        }
    }
    .lesson-summary {
        margin-top: 12px;
        height: 40px;
        display: -webkit-box;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }
    .lesson-body {
        font-size: 0.7em;
        margin-top: 6px;
        > span {
            margin-right: 12px;
            > i {
                font-style: normal;
            }
        }
    }
    .lesson-action {
        text-align: right;
        .bottom {
            margin-top: 72px;
        }
    }
    .right-btn {
        position: absolute;
        top: -6px;
        right: 0;
    }
    .add-lesson-btn {
        font-size: 15px;
        position: relative;
    }
}
.course-img {
    width: 260px;
    height: 150px;
}
.upload-bg-img {
    overflow: hidden;
    li {
        list-style: none;
        width: 180px;
        float: left;
        padding: 0;
        margin: 0px 10px 10px 0px;
        height: 105px;
        img {
            cursor: pointer;
            width: 100%;
        }
    }
    .active {
        border: 2px solid;
    }
    .custom-upload {
        cursor: pointer;
        background-color: #e0dddd;
        line-height: 105px;
        text-align: center;
    }
    input {
        display: none;
    }
}
</style>
